import React from 'react'
import PropTypes from '../../utils/propTypes'

import { Card, CardText, CardTitle, Progress, Button } from 'reactstrap'
import Typography from '../Typography'

const BillWidget = ({ order_id, amount, currency, due_date, bill_date, description, color, handleClick, ...restProps }) => {
  return (
    // <Card body {...restProps} style={{ height: '100%' }}>
    //   <div className="d-flex justify-content-between">
    //     <CardText tag="div">
    //       <Typography className="mb-0">
    //         <strong>{title}</strong>
    //       </Typography>
    //       {/* <Typography className="mb-0 text-muted small">{subtitle}</Typography> */}
    //     </CardText>
    //     <CardTitle className={`text-${color}`}>
    //       <strong>{number}</strong>
    //     </CardTitle>
    //   </div>
    //   <Progress value={value} max={max} color={progress_color} style={{ height: '8px' }} />
    //   <CardText tag="div" className="d-flex justify-content-between">
    //     <Typography tag="span" className="text-left small">
    //       <strong>{label}</strong>
    //     </Typography>
    //     <Typography tag="span" className="text-right small">
    //       <strong>{count}</strong>
    //     </Typography>
    //   </CardText>
    // </Card>
    <Card body {...restProps} style={{ height: '100%' }}>
      <div className="d-flex justify-content-between">
        <CardText tag="div">
          <Typography className="mb-0">
            <strong>{order_id}</strong>
          </Typography>
          <Typography className="mb-0">
            <strong>{currency + amount}</strong>
          </Typography>
        </CardText>
        {/* <CardTitle className={`text-${color}`}>
          <strong>{number}</strong>
        </CardTitle> */}
      </div>
      <CardText tag="div" className="d-flex justify-content-between">
        <Typography tag="span" className="text-left small">
          <strong>Due Date:</strong>
        </Typography>
        <Typography tag="span" className="text-right small">
          <strong>{due_date}</strong>
        </Typography>
      </CardText>
      <CardText tag="div" className="d-flex justify-content-between">
        <Typography tag="span" className="text-left small">
          <strong>{description}</strong>
        </Typography>
      </CardText>
      <div style={{ textAlign: 'center' }}>
        <Button className="theme-button theme-button-secondary" onClick={handleClick}>
          Pay
        </Button>
      </div>
    </Card>
  )
}

BillWidget.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'light', 'dark']),
  progress: PropTypes.shape({
    //value: PropTypes.string,
    label: PropTypes.string,
  }),
}

BillWidget.defaultProps = {
  title: '',
  subtitle: '',
  number: 0,
  color: 'primary',
  progress: {
    value: 0,
    label: '',
  },
}

export default BillWidget
